import React from "react";
import { cn } from "../../lib/utils";

const Empty = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex min-h-52 flex-col items-center justify-center gap-3 rounded-lg border border-dashed bg-muted/25 p-8 text-center", className)} {...props} />
));
Empty.displayName = "Empty";

const EmptyIcon = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("grid size-11 place-items-center rounded-md border bg-background text-accent shadow-sm [&_svg]:size-5", className)} {...props} />
));
EmptyIcon.displayName = "EmptyIcon";

const EmptyTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3 ref={ref} className={cn("text-base font-semibold text-foreground", className)} {...props} />
));
EmptyTitle.displayName = "EmptyTitle";

const EmptyDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("max-w-md text-sm text-muted-foreground", className)} {...props} />
));
EmptyDescription.displayName = "EmptyDescription";

export { Empty, EmptyDescription, EmptyIcon, EmptyTitle };
